import styled from 'styled-components';
import { Exit } from '@styled-icons/icomoon'

const ExitIcon = styled(Exit)`
`;

export default ExitIcon;
